// The key usages for KEM.
export const KEM_USAGES = ["deriveBits"];
// b"dkp_prk"
export const LABEL_DKP_PRK = new Uint8Array([100, 107, 112, 95, 112, 114, 107]);
// b"sk"
export const LABEL_SK = new Uint8Array([115, 107]);
